var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSounds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "soundsIconTitle"
  }, "Sounds") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "soundsIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7L12 17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10L15 14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8L18 16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13L21 11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4L9 20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9L6 15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13L3 11"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSounds);
export default __webpack_public_path__ + "static/media/sounds.a22216ad93cb310c0a43c4d926a11da0.svg";
export { ForwardRef as ReactComponent };